<template>
  <div>
    <el-radio-group
      v-model="type"
      size="small"
    >
      <el-radio-button
v-for="(item,index) in radioGroupList"
:key="index"
:label="index+''"
>
        {{ item }}
      </el-radio-button>      
    </el-radio-group>
  </div>
</template>
<script>
import mixin from '@/view/weappTmp/core/lib/package/element-node-mixin.js'
export default {
  name: 'SpRadioGroup',
  mixins: [mixin],
  props: {
    radioGroupList:[]
  },
  data () {
    return {
      type: null
    }
  }
}
</script>
<style scoped lang="scss"></style>
